import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-embed',
  templateUrl: './share-embed.component.html',
  styleUrls: ['./share-embed.component.less']
})
export class ShareEmbedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/share-map/share-embed/share-embed.component.ts